import React from 'react';
import chroma from 'chroma-js';

import { useTheme } from '../../../hooks/index';
import Graphic from '../Graphic';

const Feedback = props => {
  const { primary } = useTheme();

  return (
    <Graphic
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 140 145"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      {...props}>
      <path
        fill="#F3F3F4"
        d="M70.994 145c28.166 0 51-1.567 51-3.5s-22.834-3.5-51-3.5c-28.167 0-51 1.567-51 3.5s22.833 3.5 51 3.5Z"
      />
      <path
        fill="#D9D9D9"
        d="M70.155 139.214c33.775 0 61.155-27.359 61.155-61.107S103.93 17 70.155 17C36.38 17 9 44.358 9 78.107c0 33.748 27.38 61.107 61.155 61.107Z"
      />
      <path
        fill="#D9D9D9"
        d="M109.237 125.641C98.597 134.601 84.854 140 69.85 140c-10.04 0-19.516-2.418-27.875-6.702-.642-.738-.981-1.507-.981-2.298 0-5.523 16.565-10 37-10 13.139 0 24.678 1.851 31.243 4.641Z"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        d="M109.237 125.641C98.597 134.601 84.854 140 69.85 140c-10.04 0-19.516-2.418-27.875-6.702-.642-.738-.981-1.507-.981-2.298 0-5.523 16.565-10 37-10 13.139 0 24.678 1.851 31.243 4.641Z"
      />
      <path
        fill="#D9D9D9"
        fillRule="evenodd"
        d="m63.379 139.662 2.231-.598a3.217 3.217 0 0 0 2.273-3.938l-5.825-21.742a3.213 3.213 0 0 0-2.687-2.356 3.225 3.225 0 0 0-1.252.082l-21.741 5.826a3.218 3.218 0 0 0-2.274 3.938l2.496 9.313a60.984 60.984 0 0 0 11.154 5.703l13.041-3.739a1.208 1.208 0 0 1 .665 2.319l-9.753 2.796a60.866 60.866 0 0 0 11.672 2.396Zm-23.252-17.944c.153-.274.408-.478.709-.567l15.53-4.161a1.2 1.2 0 0 1 .932.104 1.198 1.198 0 0 1 .576.74 1.21 1.21 0 0 1-.45 1.283c-.13.096-.277.164-.434.202l-15.53 4.161a1.206 1.206 0 0 1-1.333-1.762Zm1.906 8.205a1.208 1.208 0 0 0 1.039 1.353c.157.021.316.01.469-.031l15.53-4.161a1.207 1.207 0 0 0-.624-2.329l-15.53 4.161a1.214 1.214 0 0 0-.732.562c-.08.137-.131.288-.152.445Z"
        clipRule="evenodd"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        fillRule="evenodd"
        d="m63.379 139.662 2.231-.598a3.217 3.217 0 0 0 2.273-3.938l-5.825-21.742a3.213 3.213 0 0 0-2.687-2.356 3.225 3.225 0 0 0-1.252.082l-21.741 5.826a3.218 3.218 0 0 0-2.274 3.938l2.496 9.313a60.984 60.984 0 0 0 11.154 5.703l13.041-3.739a1.208 1.208 0 0 1 .665 2.319l-9.753 2.796a60.866 60.866 0 0 0 11.672 2.396Zm-23.252-17.944c.153-.274.408-.478.709-.567l15.53-4.161a1.2 1.2 0 0 1 .932.104 1.198 1.198 0 0 1 .576.74 1.21 1.21 0 0 1-.45 1.283c-.13.096-.277.164-.434.202l-15.53 4.161a1.206 1.206 0 0 1-1.333-1.762Zm1.906 8.205a1.208 1.208 0 0 0 1.039 1.353c.157.021.316.01.469-.031l15.53-4.161a1.207 1.207 0 0 0-.624-2.329l-15.53 4.161a1.214 1.214 0 0 0-.732.562c-.08.137-.131.288-.152.445Z"
        clipRule="evenodd"
      />
      <path
        fill="#D9D9D9"
        d="m60.795 132.151-13.04 3.739 3.952 1.376 9.753-2.796a1.207 1.207 0 0 0-.665-2.319Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="m60.795 132.151-13.04 3.739 3.952 1.376 9.753-2.796a1.207 1.207 0 0 0-.665-2.319Z"
      />
      <path
        fill="#D9D9D9"
        d="m60.795 132.151-13.04 3.739 3.952 1.376 9.753-2.796a1.207 1.207 0 0 0-.665-2.319ZM42.064 130.393a1.208 1.208 0 0 1 .853-1.477l15.53-4.161a1.208 1.208 0 0 1 1.476.852 1.206 1.206 0 0 1-.852 1.477l-15.53 4.161a1.199 1.199 0 0 1-.915-.12 1.198 1.198 0 0 1-.562-.732Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M42.064 130.393a1.208 1.208 0 0 1 .853-1.477l15.53-4.161a1.208 1.208 0 0 1 1.476.852 1.206 1.206 0 0 1-.852 1.477l-15.53 4.161a1.199 1.199 0 0 1-.915-.12 1.198 1.198 0 0 1-.562-.732Z"
      />
      <path
        fill="#D9D9D9"
        d="M42.064 130.393a1.208 1.208 0 0 1 .853-1.477l15.53-4.161a1.208 1.208 0 0 1 1.476.852 1.206 1.206 0 0 1-.852 1.477l-15.53 4.161a1.199 1.199 0 0 1-.915-.12 1.198 1.198 0 0 1-.562-.732Z"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        fillRule="evenodd"
        d="M110.817 124.854c.279-.248.556-.497.83-.748a.5.5 0 1 0-.676-.737c-.54.495-1.089.981-1.646 1.457a.496.496 0 0 0-.186.343.496.496 0 0 0 .467.547.506.506 0 0 0 .368-.13c.283-.241.564-.485.843-.732Zm3.274-4.556a.507.507 0 0 0-.106.555.493.493 0 0 0 .283.268.49.49 0 0 0 .39-.017.5.5 0 0 0 .159-.119 61.766 61.766 0 0 0 4.316-5.089.501.501 0 0 0-.797-.605 60.844 60.844 0 0 1-4.245 5.007Zm-9.417 9.343a.504.504 0 0 0 .209-.32.474.474 0 0 0-.002-.195.487.487 0 0 0-.215-.317.498.498 0 0 0-.377-.07.49.49 0 0 0-.179.076 60.716 60.716 0 0 1-3.7 2.336.499.499 0 0 0 .123.916.5.5 0 0 0 .38-.051 61.929 61.929 0 0 0 3.761-2.375Zm-5.706 3.46a.5.5 0 0 0-.472-.882c-18.15 9.695-39.99 9.416-57.774-.37a.49.49 0 0 0-.38-.042.494.494 0 0 0-.359.424.5.5 0 0 0 .256.494c18.08 9.947 40.278 10.232 58.729.376Zm24.138-25.146a.494.494 0 0 0-.043.38.497.497 0 0 0 .62.342.494.494 0 0 0 .299-.239c9.968-18.084 10.274-40.283.434-58.727a.5.5 0 0 0-.883.47c9.68 18.144 9.379 39.983-.427 57.774Zm-.639-59.687a.501.501 0 0 0 .865-.503 60.76 60.76 0 0 0-2.374-3.762.5.5 0 0 0-.826.564 60.066 60.066 0 0 1 2.335 3.7v.001Zm-89.69 79.612a.492.492 0 0 0 .7-.097.49.49 0 0 0 .098-.37.501.501 0 0 0-.193-.33 60.521 60.521 0 0 1-5.007-4.244.498.498 0 0 0-.686.04.5.5 0 0 0-.001.687 61.529 61.529 0 0 0 5.09 4.314Zm-8.211-7.484a.5.5 0 1 0 .737-.676 61.999 61.999 0 0 1-.7-.776C2.462 93.874 4.83 55.586 29.907 33.401c25.076-22.185 63.367-19.87 85.551 5.16.231.263.46.526.686.79a.503.503 0 0 0 .716.069.502.502 0 0 0 .044-.718 61.894 61.894 0 0 0-.655-.755l-.006-.008-.036-.04-.035-.04a62.576 62.576 0 0 0-3.805-3.926.48.48 0 0 0-.065-.073 61.243 61.243 0 0 0-5.09-4.314.495.495 0 0 0-.128-.071 61.208 61.208 0 0 0-7.187-4.653.496.496 0 0 0-.146-.12c-18.08-9.949-40.278-10.234-58.728-.377a.498.498 0 0 0-.22.237 57.12 57.12 0 0 0-1.407.785.498.498 0 0 0-.318.063 61.598 61.598 0 0 0-3.762 2.375.5.5 0 0 0-.195.262 62.219 62.219 0 0 0-4.8 3.673.498.498 0 0 0-.305.12c-.566.483-1.123.977-1.672 1.48a.5.5 0 0 0-.156.288 62.467 62.467 0 0 0-2.724 2.682.499.499 0 0 0-.29.151 61.682 61.682 0 0 0-4.316 5.089.498.498 0 0 0-.102.308 61.228 61.228 0 0 0-4.513 6.935.499.499 0 0 0-.234.215c-9.97 18.084-10.275 40.282-.434 58.727.025.048.058.09.095.125.302.565.613 1.127.934 1.684.012.047.03.093.055.136a61.3 61.3 0 0 0 2.373 3.763.496.496 0 0 0 .076.087 62.091 62.091 0 0 0 4.71 6.056l.036.04.043.048c.22.25.443.497.669.742Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M89.118 113.213c7.403 0 13.404-5.996 13.404-13.393s-6.001-13.393-13.404-13.393-13.404 5.996-13.404 13.393 6.001 13.393 13.404 13.393Z"
      />
      <path fill="#fff" stroke={primary} d="M1 16h88v85H1V16Z" />
      <path fill="#fff" d="M5.994 21h78v76h-78V21Z" />
      <path
        fill="#D9D9D9"
        d="M19.994 21h-13a1 1 0 0 0-1 1v74a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V22a1 1 0 0 0-1-1ZM82.994 30.214h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 39.214h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 48.214h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 57.213h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 66.213h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 75.213h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM38.77 21H26.4a.905.905 0 0 0 0 1.81H38.77a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill={primary}
        d="M83.089 21h-5.281a.905.905 0 0 0 0 1.81h5.28a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#F3F3F4"
        d="M74.225 21h-5.281a.905.905 0 0 0 0 1.81h5.28a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#D9D9D9"
        d="M33.453 24.619h-7.054a.905.905 0 0 0 0 1.81h7.054a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#fff"
        d="M89.114 113.213c7.403 0 13.404-5.996 13.404-13.393s-6.001-13.393-13.404-13.393S75.71 92.423 75.71 99.82s6.001 13.393 13.404 13.393Z"
      />
      <path
        fill="url(#a)"
        fillRule="evenodd"
        d="M89.114 113.214c7.403 0 13.404-5.997 13.404-13.394s-6.001-13.393-13.404-13.393S75.71 92.423 75.71 99.82s6.001 13.394 13.404 13.394Zm1.675-18.416a1.675 1.675 0 0 0-3.35 0v3.348h-3.351a1.675 1.675 0 1 0 0 3.348h3.35v3.349a1.674 1.674 0 0 0 1.676 1.676 1.677 1.677 0 0 0 1.676-1.676v-3.349h3.35a1.674 1.674 0 1 0 0-3.348h-3.35l-.001-3.348Z"
        clipRule="evenodd"
      />
      <path
        fill="#D9D2E5"
        d="M119.994 22c0-9.389-7.611-17-17-17s-17 7.611-17 17 7.611 17 17 17 17-7.611 17-17Z"
      />
      <path
        fill="#fff"
        d="M119.994 22c0-9.389-7.611-17-17-17s-17 7.611-17 17 7.611 17 17 17 17-7.611 17-17Z"
      />
      <path
        fill={primary}
        fillOpacity=".25"
        d="M119.994 22c0-9.389-7.611-17-17-17s-17 7.611-17 17 7.611 17 17 17 17-7.611 17-17Z"
      />
      <path
        stroke={primary}
        d="M119.994 22c0-9.389-7.611-17-17-17s-17 7.611-17 17 7.611 17 17 17 17-7.611 17-17Z"
      />
      <path
        fill={primary}
        d="M93.794 22.575a1.725 1.725 0 0 1 3.45 0v6.9a1.725 1.725 0 1 1-3.45 0v-6.9Zm4.6-.192v6.246a2.3 2.3 0 0 0 1.27 2.057l.058.028c.639.32 1.344.486 2.058.486h6.228a2.3 2.3 0 0 0 2.255-1.849l1.38-6.9a2.287 2.287 0 0 0-.477-1.91 2.297 2.297 0 0 0-1.778-.841h-4.094v-4.6a2.297 2.297 0 0 0-2.3-2.3 1.149 1.149 0 0 0-1.15 1.15v.767c0 .995-.323 1.964-.92 2.76l-1.61 2.146a4.6 4.6 0 0 0-.92 2.76ZM111.994 11a9 9 0 1 0 18 0 9 9 0 0 0-18 0Z"
      />
      <path
        stroke={primary}
        strokeWidth="2"
        d="M111.994 11a9 9 0 1 0 18 0 9 9 0 0 0-18 0Z"
      />
      <path
        fill="#fff"
        d="M124.594 10.775a.676.676 0 0 1-1.35 0v-2.7a.673.673 0 0 1 1.152-.477.673.673 0 0 1 .198.477v2.7Zm-1.8.075V8.406a.9.9 0 0 0-.498-.805l-.022-.011a1.803 1.803 0 0 0-.805-.19h-2.438a.897.897 0 0 0-.882.724l-.54 2.7a.904.904 0 0 0 .187.747.895.895 0 0 0 .695.329h1.603v1.8a.9.9 0 0 0 .9.9.45.45 0 0 0 .45-.45v-.3c0-.39.126-.769.36-1.08l.63-.84c.233-.312.36-.69.36-1.08Z"
      />
      <path
        fill={primary}
        fillOpacity=".25"
        d="M124.594 10.775a.676.676 0 0 1-1.35 0v-2.7a.673.673 0 0 1 1.152-.477.673.673 0 0 1 .198.477v2.7Zm-1.8.075V8.406a.9.9 0 0 0-.498-.805l-.022-.011a1.803 1.803 0 0 0-.805-.19h-2.438a.897.897 0 0 0-.882.724l-.54 2.7a.904.904 0 0 0 .187.747.895.895 0 0 0 .695.329h1.603v1.8a.9.9 0 0 0 .9.9.45.45 0 0 0 .45-.45v-.3c0-.39.126-.769.36-1.08l.63-.84c.233-.312.36-.69.36-1.08Z"
      />
      <path
        fill="#fff"
        d="M136.994 69.5h-13a1.5 1.5 0 0 0-1.5 1.5v13a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5V71a1.5 1.5 0 0 0-1.5-1.5Z"
      />
      <path
        stroke={primary}
        d="M137.5 69.5h-13A1.5 1.5 0 0 0 123 71v13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 139 84V71a1.5 1.5 0 0 0-1.5-1.5Z"
      />
      <path
        stroke={primary}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m131.947 74.326.678-.74a.86.86 0 0 1 1.003-.216c.112.05.212.124.293.216l.649.707c.358.39.358 1.024 0 1.414l-.679.74m-1.944-2.121-4.407 4.808a1.035 1.035 0 0 0-.265.619l-.111 1.37c-.025.31.212.57.497.542l1.256-.121a.888.888 0 0 0 .567-.289l4.407-4.808m-1.944-2.121 1.944 2.121"
      />
      <defs>
        <linearGradient
          id="a"
          x1="89.114"
          x2="89.114"
          y1="86.427"
          y2="113.214"
          gradientUnits="userSpaceOnUse">
          <stop stopColor={chroma(primary).brighten(0.5 - 0)} />
          <stop offset="1" stopColor={primary} />
        </linearGradient>
      </defs>
    </Graphic>
  );
};
export default Feedback;
